import moment from 'moment';

export const DATE_TYPE = {'year' : moment().endOf('year'), 'month' : moment().endOf('month'), 'day' : moment()};
